import { motion } from 'framer-motion';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const CashRegisterManagementPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="inline-block mb-6 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
                <span className="text-red text-sm font-medium">現金管理</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                レジ現金管理
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Article Content */}
        <article className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="space-y-8 text-gray-700 leading-relaxed text-[17px]">
                <p>
                  友人が大阪の北新地でバーを経営しています。
                </p>

                <p>
                  そこに別の友人が閉店ぐらいまでいたとき、経営している友人が真剣におかねを数えていて
                </p>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-chat-quote-line text-red text-xl"></i>
                    </div>
                    <div>
                      <p className="text-xl font-bold text-gray-900 italic">
                        「カネ勘定に人生をかける〇〇さん。」
                      </p>
                      <p className="text-gray-600 mt-2">
                        いわれていました。
                      </p>
                    </div>
                  </div>
                </div>

                <p className="text-xl font-semibold text-gray-900">
                  これはとても重要なことなのです。
                </p>

                <p>
                  バーなどの現金商売の経営で現金がなくなることはよくあります。
                </p>

                <div className="bg-white rounded-2xl p-8 border-l-4 border-red shadow-sm my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">実践的な現金管理システム</h2>
                  <p className="mb-6">
                    わたしが顧問している飲食店では、レジ現金をきちんと管理するためのシートを導入し、毎日現金をきちんと残高を合わせています。
                  </p>
                  
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-calculator-line text-red"></i>
                      現金管理の計算式
                    </h3>
                    <div className="space-y-4">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <span className="text-red font-bold text-sm">1</span>
                        </div>
                        <div>
                          <strong className="text-gray-900">開店前のおつり等の現金</strong>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 pl-11">
                        <i className="ri-add-line text-red text-xl"></i>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <span className="text-red font-bold text-sm">2</span>
                        </div>
                        <div>
                          <strong className="text-gray-900">売り上げをしたロールペーパー</strong>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 pl-11">
                        <i className="ri-subtract-line text-red text-xl"></i>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <span className="text-red font-bold text-sm">3</span>
                        </div>
                        <div>
                          <strong className="text-gray-900">出金がある場合その記録</strong>
                        </div>
                      </div>
                      <div className="border-t-2 border-red my-4"></div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-red rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-equal-line text-white"></i>
                        </div>
                        <div>
                          <strong className="text-red text-lg">計算上の現金</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">突き合わせの重要性</h2>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl p-6 border border-red/20">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-calculator-line text-red text-xl"></i>
                        </div>
                        <div>
                          <strong className="text-gray-900 text-lg">計算上の現金</strong>
                        </div>
                      </div>
                      <p className="text-gray-600 text-sm">
                        上記の計算式で算出
                      </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 border border-red/20">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-hand-coin-line text-red text-xl"></i>
                        </div>
                        <div>
                          <strong className="text-gray-900 text-lg">実際に数えた現金</strong>
                        </div>
                      </div>
                      <p className="text-gray-600 text-sm">
                        レジ内の実際の現金
                      </p>
                    </div>
                  </div>
                  <div className="mt-6 flex items-center justify-center">
                    <div className="bg-red text-white px-6 py-3 rounded-full font-bold text-lg">
                      この2つを突き合わせ
                    </div>
                  </div>
                </div>

                <p>
                  単純ですが、やらないとなぜかいつのまにか現金がなくなるということがおこります。
                </p>

                <div className="bg-white rounded-2xl p-8 border-l-4 border-red shadow-sm my-10">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-lightbulb-line text-red text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">経営安定の秘訣</h3>
                      <p className="text-lg">
                        経営を安定させるには、こういう地味なことが重要だったりします。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">現金管理のメリット</h2>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">現金の紛失を防ぐ</strong>
                        <p className="text-gray-600 text-sm mt-1">毎日の確認で問題を早期発見</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">売上の正確な把握</strong>
                        <p className="text-gray-600 text-sm mt-1">日々の売上を確実に記録</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">従業員の意識向上</strong>
                        <p className="text-gray-600 text-sm mt-1">現金管理の重要性を共有</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">経営の安定化</strong>
                        <p className="text-gray-600 text-sm mt-1">地道な管理が信頼を生む</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-8 mt-12">
                  <p className="text-gray-600">
                    現金商売において、日々の現金管理は経営の基本中の基本です。シンプルな仕組みでも、毎日継続することで大きな効果を発揮します。地味な作業ですが、これが経営を安定させる重要な要素となります。
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">関連記事</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <a
                href="/blog/company-history-profile"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/company-history-profile');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/078a2e67b8da06ee706de50aa4613620.jpg"
                    alt="会社の沿革"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    会社の沿革
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    会社の沿革、経営者のプロフィールは重要
                  </h3>
                </div>
              </a>

              <a
                href="/blog/business-planning"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/business-planning');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=business%20planning%20documents%20with%20financial%20charts%20and%20strategic%20roadmap%20on%20clean%20desk%2C%20professional%20workspace%20with%20laptop%20and%20planning%20materials%2C%20organized%20business%20setting%20with%20natural%20lighting%2C%20corporate%20photography%20style%20emphasizing%20strategic%20thinking&width=800&height=500&seq=blog-002&orientation=landscape"
                    alt="事業計画"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    事業計画
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    事業計画をつくるのはこんな感じです
                  </h3>
                </div>
              </a>

              <a
                href="/blog/multiple-income"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/multiple-income');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=multiple%20income%20streams%20concept%20with%20financial%20documents%20and%20calculator%2C%20organized%20tax%20preparation%20materials%20on%20modern%20desk%2C%20professional%20accounting%20workspace%20with%20clean%20aesthetic%2C%20business%20photography%20emphasizing%20financial%20management&width=800&height=500&seq=blog-003&orientation=landscape"
                    alt="確定申告"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    確定申告
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    複数の収入をもつ
                  </h3>
                </div>
              </a>

              <a
                href="/blog/depreciation"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/depreciation');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=depreciation%20concept%20with%20business%20assets%20and%20financial%20calculations%2C%20professional%20accounting%20documents%20on%20modern%20desk%2C%20clean%20office%20environment%20with%20natural%20lighting%2C%20business%20photography%20emphasizing%20financial%20planning%20and%20asset%20management&width=800&height=500&seq=blog-005&orientation=landscape"
                    alt="減価償却"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    税務
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    減価償却
                  </h3>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-red-dark to-red">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">
                現金管理のお悩み、お気軽にご相談ください
              </h2>
              <p className="text-white/90 mb-10 text-lg leading-relaxed">
                会計・税務の専門家として、あなたのビジネスをサポートします。<br />
                まずは無料相談で、お気軽にご相談ください。
              </p>
              <a
                href="/#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
                className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                無料相談を予約する
              </a>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CashRegisterManagementPage;